import { render, staticRenderFns } from "./Warestore.vue?vue&type=template&id=3473e028&"
import script from "./Warestore.vue?vue&type=script&lang=js&"
export * from "./Warestore.vue?vue&type=script&lang=js&"
import style0 from "./Warestore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports